module.exports = __webpack_public_path__ + "img/Madagascar.dc842bf0.png";